import { createFileRoute } from "@tanstack/react-router";
import { GoalsPage } from "@/components/Goals";

function RouteComponent() {
  return <GoalsPage />;
}

export const Route = createFileRoute("/_authenticated/goals/")({
  component: RouteComponent,
  staticData: { page: "goals" },
});
